module.exports = __webpack_public_path__ + "img/reference10.db3ce388.jpg";